import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSearchParams, Link } from "react-router-dom";

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token"); // 从 URL 中抓取 token
  const [status, setStatus] = useState("Verifying...");

  useEffect(() => {
    const verifyUserEmail = async () => {
      if (!token) {
        setStatus("Invalid or missing token.");
        return;
      }
      try {
        const response = await axios.post("/signup/verify-email", { token });
        setStatus(response.data.message || "Email verified successfully!");
      } catch (error) {
        setStatus(error.response?.data?.detail || "Verification failed. Link may be expired.");
      }
    };

    verifyUserEmail();
  }, [token]);

  return (
    <div className="login-wrapper" style={{ textAlign: "center" }}>
      <h2>Email Verification</h2>
      <p style={{ marginTop: "20px", fontSize: "18px" }}>{status}</p>
      <div style={{ marginTop: "30px" }}>
        <Link to="/login" className="submit-btn" style={{ textDecoration: "none", padding: "10px 20px" }}>
          Go to Login
        </Link>
      </div>
    </div>
  );
};

export default VerifyEmail;